import React from "react"
import { Button, Col, FormControl, Image, Modal, Row, Table } from "react-bootstrap"
import {
  DATE_FORMAT_STR,
  DEFAULT_NB_DAYS_EXTENSION,
  LoanCollateralEnum,
  validatePhoneNumber
} from "../../lib/utils"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import AlertModal from "../fragments/AlertModal"
import FieldGroup from '../fragments/FieldGroup'
import FontAwesome from "react-fontawesome"
import moment from "moment"
import store from "store"

const EmergencyLockStateType = {
  YES: 'Yes',
  NO: 'No',
  LockPending: 'LockPending',
  UnlockPending: 'UnlockPending',
  LockFailed: 'LockFailed',
  UnlockFailed: 'UnlockFailed',
},

DeviceOperationType = {
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK',
  WHITELIST: 'WHITELIST',
}

export default class ImeiList extends React.Component {

  dateNow = moment().format(DATE_FORMAT_STR)

  state = {
    title: '',
    imei: null,
    deviceInfo: {},
    running: false,
    success: false,
    error: null,
    changePhoneNumber: false,
    phoneNumber: '',
    phoneNumberValidationState: null,
    showRegisterDevice: false,
    isAcceptedImei: false,
    authQr: null,
    showFullAuthQR: false,
    showExtendUsage: false,
    timestamp: moment().format(DATE_FORMAT_STR),
  }

  constructor(props) {
    super(props)
    const organization = store.get("organization")
    this.nbDays = organization ? organization.nbDaysManualExtension : DEFAULT_NB_DAYS_EXTENSION
  }

  imeiClicked = imei => {
    this.setState({
      imei,
      deviceInfo: {},
      changePhoneNumber: false,
      phoneNumber: '',
      phoneNumberValidationState: null,
      showRegisterDevice: false,
      isAcceptedImei: false,
      authQr: null,
      showFullAuthQR: false,
      showExtendUsage: false,
    })

    this.checkImei(imei)
    this.checkAcceptedImei(imei)
  }

  checkAcceptedImei = imei => blockingFetchService(
    accessToken => apiServerApi.acceptedImei(accessToken, imei),
    resp => this.setState({ isAcceptedImei: !!resp}),
    error => console.error(error.text),
    _ => {}
  )

  checkImei = imei => {

    this.setState({
      title: 'Checking state',
      running: true,
      success: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.deviceStatus(accessToken, imei),
      deviceInfo => this.setState({ deviceInfo }),
      error => {
        this.getImeiFailed(error)
        console.error(error)
      },
      _ => this.setState({ running: false })
    )
  }

  getImeiFailed = error => this.setState({
    error: error.text,
    title: '',
    showRegisterDevice: error.status === 404
  })

  deviceOperationClicked = (disabled, imei, type, title, shouldReload) => {

    if(disabled) return

    this.setState({
      title,
      running: true,
      success: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.deviceOperation(accessToken, imei, type),
      _ => {
        if (shouldReload) {
          this.checkImei(imei)
        }
        else {
          this.setState({ success: true })
        }
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  getAuthQR = (disabled, imei) => {

    if(disabled) return

    this.setState({
      title: 'Retrieving Auth QR..',
      running: true,
      success: false,
      error: null,
      showExtendUsage: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.offlineAuthQr(accessToken, imei),
      resp => this.setState({ authQr: resp.qrcode }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  phoneNumberChanged = phoneNumber => this.setState({
    phoneNumber,
    phoneNumberValidationState: validatePhoneNumber(phoneNumber)
  })

  doChangePhoneNumber = imei => {

    const { phoneNumber, phoneNumberValidationState } = this.state
    if(phoneNumberValidationState === 'error') {
      this.setState({ error: 'Check the phone number' })
      return
    }

    this.setState({
      title: '',
      running: true,
      success: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.changeSIM(accessToken, imei, phoneNumber),
      _ => {
        this.setState({ changePhoneNumber: false })
        this.checkImei(imei)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  doExtendUsage = (imei, timestamp) => {

    const choosedDate = moment(timestamp).startOf('day'),
    now = moment().startOf('day'),
    lastDate = moment().add(this.nbDays, 'days').startOf('days')

    if (!choosedDate.isBetween(now, lastDate, undefined, '[]')) {
      this.setState({ error: 'Invalid date!' })
      return
    }

    this.setState({
      title: 'Updating extension',
      running: true,
      success: false,
      error: null,
    })

    const data = moment(timestamp).endOf("day").unix()
    blockingFetchService(
      accessToken => apiServerApi.extendUsage(accessToken, imei, data),
      _ => {
        this.setState({ showExtendUsage: false })
        this.checkImei(imei)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  enableExtendUsage = disabled => {

    if(disabled) return

    this.setState({ 
      showExtendUsage: true,
      title: '',
      error: null,
      success: false,
      authQr: null,
    })
  }

  registerDevice = (disabled, imei) => {

    if(disabled) return

    this.setState({
      title: 'Register device',
      running: true,
      success: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.retryRegisterDevice(accessToken, imei),
      _ => this.checkImei(imei),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  refreshClicked = imei => {
    this.setState({ authQr: null })
    this.checkImei(imei)
  }

  cancelShowAuthQR = () => this.setState({ authQr: null })

  renderChangeSIM = imei => {
    const { phoneNumber, phoneNumberValidationState, running } = this.state
    return (
      <div>
        <FieldGroup
          id="phoneNumber"
          type="text"
          label=""
          placeholder="Enter phone number"
          validationState={ phoneNumberValidationState }
          value={ phoneNumber }
          onChange={e => this.phoneNumberChanged(e.target.value)}
        />

        <div className='align-right'>
          <Button onClick={() => this.setState({ changePhoneNumber: false, error: null })}>
            Cancel
          </Button>

          <Button type='submit' bsStyle='info' className='ml-10'
            onClick={() => this.doChangePhoneNumber(imei)}
            disabled={ running || phoneNumberValidationState === 'error' }>
            Confirm
          </Button>
        </div>
      </div>
    )
  }

  renderPhoneNumber = (phoneNumber, changePhoneNumber) => {

    const iconName = phoneNumber ? 'pencil' : 'plus-circle',
    text = phoneNumber ? 'Change' : 'Add'

    return (
      <div className="flex-row m-10">
        <strong>Phone number</strong>
        <span>{ phoneNumber }</span>

        { !changePhoneNumber ?
        <small className="blue cursor-pointer" title='Update Phone Number'
          onClick={() => this.setState({ changePhoneNumber: true, error: null, success: false })}>
          <FontAwesome name={ iconName } /> { text }
        </small>
        : null }
      </div>
    )
  }

  renderOperationButton = (text, disabled, title, iconName, onClick) => (
    <p className={ disabled ? '' : 'cursor-pointer hot-color' } title={ title }
      onClick={ onClick }>
      <FontAwesome name={ iconName } size="lg"/>
      <span>{ text }</span>
    </p>
  )

  renderDeviceActionButtons = () => {

    const { imei, deviceInfo, running, showRegisterDevice, isAcceptedImei } = this.state,

    { emergencyLockState: type, extendedUntil } = deviceInfo,
    disableAuthQR = !isAcceptedImei || running,
    disableWhitelist = !isAcceptedImei || running

    let disableLock = true,
      disableUnlock = true

    if(type) {
      disableLock = type === EmergencyLockStateType.LockPending || running
        || type === EmergencyLockStateType.YES
      disableUnlock = type === EmergencyLockStateType.UnlockPending || running
        || type === EmergencyLockStateType.NO
    }

    let canExtendUsage = false
    if (this.nbDays && extendedUntil) {
      canExtendUsage = moment(extendedUntil).startOf("day").isBefore(moment().startOf("day"))
    }

    return (
      <div className="device-action-button">
        { this.renderOperationButton(
          'Lock',
          disableLock,
          'Lock the device',
          'lock',
          () => this.deviceOperationClicked(disableLock, imei, DeviceOperationType.LOCK, 'Locking', true)
        )}

        { this.renderOperationButton(
          'Unlock',
          disableUnlock,
          'Unlock the device',
          'unlock',
          () => this.deviceOperationClicked(disableUnlock, imei, DeviceOperationType.UNLOCK, 'Unlocking', true)
        )}

        { this.renderOperationButton(
          'Whitelist',
          disableWhitelist,
          'Whitelist device',
          'unlink',
          () => this.deviceOperationClicked(disableWhitelist, imei, DeviceOperationType.WHITELIST, 'Whitelisting')
        )}

        { this.renderOperationButton(
          'Auth QR',
          disableAuthQR,
          'Get Auth QR code',
          'qrcode',
          () => this.getAuthQR(disableAuthQR, imei)
        )}

        { canExtendUsage && this.renderOperationButton(
          'Extend',
          running,
          'Extend device',
          'long-arrow-right',
          () => this.enableExtendUsage(running)
        )}

        { showRegisterDevice && this.renderOperationButton(
          'Reg. device',
          running,
          'Register device',
          'save',
          () => this.registerDevice(running, imei)
        )}
      </div>
    )
  }

  getReadableDate = timestamp => timestamp ? moment(timestamp).format('lll') : ''

  renderContentTable = deviceInfo => {

    const { enrolled, extendedAt, extendedUntil, registeredAt, imsi, emergencyLockState } = deviceInfo,
    fontEnrolled = enrolled === true ? 'check' : 'close',
    titleEnrolled = enrolled === true ? 'Yes' : 'No',
    classEnrolled = enrolled === true ? 'green' : 'red',

    iconEnrolled = enrolled !== undefined && (
      <span>
        <FontAwesome name={ fontEnrolled } /> { titleEnrolled }
      </span>
    )

    return (
      <Table responsive striped condensed hover>
        <tbody>
          <tr>
            <td>Enrolled</td>
            <td className={ classEnrolled }>
              { iconEnrolled }
            </td>
          </tr>

          <tr>
            <td>Registered at</td>
            <td>{ this.getReadableDate(registeredAt) }</td>
          </tr>

          <tr>
            <td>Extended at</td>
            <td>{ this.getReadableDate(extendedAt) }</td>
          </tr>

          <tr>
            <td>Extended until</td>
            <td>{ this.getReadableDate(extendedUntil) }</td>
          </tr>

          <tr>
            <td>IMSI</td>
            <td>{ imsi }</td>
          </tr>

          <tr>
            <td>Emergency locked</td>
            <td>{ emergencyLockState }</td>
          </tr>
        </tbody>
      </Table>
    )
  }

  renderDeviceInfo = () => {
    const { imei, deviceInfo, changePhoneNumber} = this.state
    return (
      <div>
        { this.renderPhoneNumber(deviceInfo.phoneNumber, changePhoneNumber) }
        { changePhoneNumber ? this.renderChangeSIM(imei) : this.renderContentTable(deviceInfo) }
      </div>
    )
  }

  renderStatuses = () => {

    const { error, success, running, title } = this.state
    if(!error && !success && !running) return null

    const statusText = error ? error : running ? 'Running..' : success ? 'Completed successfully' : null,
    statusFontName = error ? 'exclamation-circle' : running ? 'clock-o' : 'check',
    statusClassName = error ? 'error-color' : running ? 'hot-color' : 'green'

    return (
      <div className="align-center">
        <h4>{ title }</h4>
        <p className={ statusClassName }>
          <FontAwesome name={ statusFontName }/> { statusText }
        </p>
      </div>
    )
  }

  renderLargeImage = (authQr, show, close ) => (
    <Modal show={ show } onHide={ close } >
      <Modal.Header closeButton>Auth QR code</Modal.Header>
      <Modal.Body>
        <Image alt='Auth QR code' src={ authQr } width="100%" title="Auth QR code"/>
      </Modal.Body>
    </Modal>
  )

  renderAuthQr = authQr => (
    <div className="align-center">
      <h4>Auth QR code</h4>
      <Image alt='Auth' src={ authQr } width={ 300 } className="cursor-pointer" 
        title="Click to expand" 
        onClick={() => this.setState({ showFullAuthQR: true}) }
      />
      <p>
        <small className="cursor-pointer hot-color" onClick={ this.cancelShowAuthQR }
          title='Close Auth QR code'>
          <FontAwesome name='close'/> Close
        </small>
      </p>
    </div>
  )

  renderExtendUsage = () => {

    const { imei, running, timestamp } = this.state,
    lastDate = moment().add(this.nbDays, 'days').format(DATE_FORMAT_STR)

    return (
      <div>
        <p>
          <strong>Choose the new extension date</strong>
        </p>

        <FormControl type="date" placeholder="Transaction Date"
          value={ timestamp }
          onChange={e => this.setState({ timestamp: e.target.value, error: null })}
          min={ this.dateNow }
          max={ lastDate }
        />

        <div className='align-right mt-10'>
          <Button onClick={() => this.setState({ showExtendUsage: false, error: null })}>
            Cancel
          </Button>

          <Button type='submit' bsStyle='info' className='ml-10'
            onClick={() => this.doExtendUsage(imei, timestamp)}
            disabled={ running }>
            Confirm
          </Button>
        </div>
      </div>
    )
  }

  renderRefreshButton = (imei, running) => (
    <p className="align-right">
    { running ? '...' :
      <small className="cursor-pointer" onClick={() => this.refreshClicked(imei)}
        title='Refresh content'>
        <FontAwesome name='refresh'/> refresh
      </small>
    }
    </p>
  )

  renderCardContent = () => {
    const { imei, running, authQr, showFullAuthQR, showExtendUsage } = this.state
    return (
      <Row>
        <Col md={5} className="align-center hot-color br-1">

          <h3>
            <FontAwesome name='mobile-phone' size="4x"/><br />
            { imei }
          </h3>

          { this.renderDeviceActionButtons() }
          { this.renderRefreshButton(imei, running) }
        </Col>

        <Col md={7}>

          { this.renderStatuses() }

          { authQr 
          ? this.renderAuthQr(authQr)
          : showExtendUsage
            ? this.renderExtendUsage()
            : this.renderDeviceInfo() 
          }

          { this.renderLargeImage(authQr, showFullAuthQR, () => this.setState({ showFullAuthQR: false })) }

        </Col>
      </Row>
    )
  }

  render() {

    const { loan, canEditDevice } = this.props,
    { bundleQty, imeis, bundle } = loan,
    { imei } = this.state

    if(bundle.loanCollateral !== LoanCollateralEnum.DEVICE) return null

    const submittedImeis = imeis ? imeis.length : 0,
    title = `${ submittedImeis }/${ bundleQty } IMEIs have been submitted!`,
    imeisHtml = []

    if(imeis && imeis.length) {
      imeis.forEach((imei, index) =>
        imeisHtml.push(
          canEditDevice ?
          <span key={ index } className="gray cursor-pointer imei-item"
            title={ imei } onClick={() => this.imeiClicked(imei)}>
            <small>{ index + 1 }{ ')' }</small> { imei }
          </span>
          : <span key={ index } className="gray imei-item" title={ imei }>
            <small>{ index + 1 }{ ')' }</small> { imei }
          </span>
        )
      )
    }

    return (
      <tr>
        <td className="col1 strong v-center" title={ title }>
          <FontAwesome name='mobile-phone'/> IMEIs <small className="gray">
            ({ submittedImeis }/{ bundleQty })</small>
        </td>

        <td className="col2"> { imeisHtml }
          <AlertModal
            title="Device info"
            show={ imei !== null }
            close={() => this.setState({ imei: null })}
            body={ this.renderCardContent() }
          />
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Loans/ImeiList.js